module.exports = __webpack_public_path__ + "static/media/image-crop-22-desktop.990551d0.jpg";